module.exports = new __parcel__URL__("review.24e874f5.png").toString();